import React, { useContext } from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { Context } from '../../../context/Context';
import { useTrackingManager } from '../../../utils/useTrackingManager';
import VtpHeadline from './VtpHeadline';
import { VtpButtonGroup } from '../SubPageNavigationStyles';
import { useBreakpoint } from '../../../utils/useBreakpoint';

const StyledTextButton = styled(TextButton)`
  white-space: ${process.env.IS_LEGACY ? '' : 'nowrap'};
`;

const VtpButtons = () => {
  const { vtpData } = useContext(Context);
  const { newCarsText, usedCarsText, newCarsAmount, newCarsUrl, usedCarsAmount, usedCarsUrl } =
    vtpData;
  const { click } = useTrackingManager();
  const { breakpoint } = useBreakpoint();

  return (
    <>
      <VtpHeadline />
      <VtpButtonGroup>
        {newCarsAmount !== 0 && newCarsUrl !== undefined && (
          <StyledTextButton
            variant="secondary"
            href={newCarsUrl}
            isFullWidth
            onClick={() =>
              click(
                'cta',
                newCarsText.replace(/\s?\(\d+\)/g, ''),
                newCarsUrl,
                `${newCarsAmount}`,
                breakpoint,
                'secondary',
              )
            }
            size="sm"
          >
            {newCarsText}
          </StyledTextButton>
        )}
        {usedCarsAmount !== 0 && usedCarsUrl !== undefined && (
          <StyledTextButton
            variant="secondary"
            href={usedCarsUrl}
            isFullWidth
            onClick={() =>
              click(
                'cta',
                usedCarsText.replace(/\s?\(\d+\)/g, ''),
                usedCarsUrl,
                `${usedCarsAmount}`,
                breakpoint,
                'secondary',
              )
            }
            size="sm"
          >
            {usedCarsText}
          </StyledTextButton>
        )}
      </VtpButtonGroup>
    </>
  );
};
export default VtpButtons;
